(function () {
  var core = window.DPPThemeProduct || {}
  var prefersReducedMotion = core.prefersReducedMotion

  function setupProductDescriptionEmbeds() {
    var descriptionBlocks = Array.prototype.slice.call(document.querySelectorAll('[data-product-description]'))
    if (descriptionBlocks.length === 0) return

    function getYouTubeEmbedUrl(rawUrl) {
      if (!rawUrl) return null

      var parsedUrl
      try {
        parsedUrl = new URL(rawUrl)
      } catch (error) {
        try {
          parsedUrl = new URL(rawUrl, window.location.origin)
        } catch (nestedError) {
          return null
        }
      }

      var host = parsedUrl.hostname.replace(/^www\./, '')
      var videoId = ''

      if (host === 'youtu.be') {
        videoId = parsedUrl.pathname.replace(/^\//, '').split('/')[0]
      } else if (host === 'youtube.com' || host === 'm.youtube.com') {
        if (parsedUrl.pathname === '/watch') {
          videoId = parsedUrl.searchParams.get('v') || ''
        } else if (parsedUrl.pathname.indexOf('/shorts/') === 0) {
          videoId = parsedUrl.pathname.replace('/shorts/', '').split('/')[0]
        } else if (parsedUrl.pathname.indexOf('/embed/') === 0) {
          videoId = parsedUrl.pathname.replace('/embed/', '').split('/')[0]
        }
      }

      if (!videoId) return null
      return 'https://www.youtube.com/embed/' + encodeURIComponent(videoId)
    }

    function createVideoNode(embedUrl) {
      var wrapper = document.createElement('div')
      wrapper.className = 'product-description-video'
      wrapper.innerHTML = '' +
        '<iframe src="' + embedUrl + '" title="YouTube video" loading="lazy" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>'
      return wrapper
    }

    descriptionBlocks.forEach(function (block) {
      var links = Array.prototype.slice.call(block.querySelectorAll('a[href]'))
      links.forEach(function (link) {
        var embedUrl = getYouTubeEmbedUrl(link.href)
        if (!embedUrl) return

        var replacementNode = createVideoNode(embedUrl)
        var parent = link.parentElement
        var parentText = parent ? parent.textContent.trim() : ''
        var linkText = link.textContent.trim()
        var shouldReplaceParent = parent && parent.children.length === 1 && parentText === linkText

        if (shouldReplaceParent) {
          parent.replaceWith(replacementNode)
        } else {
          link.replaceWith(replacementNode)
        }
      })

      var textCandidates = Array.prototype.slice.call(block.querySelectorAll('p,li,div'))
      textCandidates.forEach(function (node) {
        if (node.children.length > 0) return
        var rawText = node.textContent.trim()
        if (!rawText) return
        var embedUrl = getYouTubeEmbedUrl(rawText)
        if (!embedUrl) return
        node.replaceWith(createVideoNode(embedUrl))
      })
    })
  }

  function setupPdpAnchorLinks() {
    var links = Array.prototype.slice.call(document.querySelectorAll('[data-pdp-anchor-link]'))
    if (links.length === 0) return

    var linkItems = links
      .map(function (link) {
        var href = link.getAttribute('href') || ''
        if (!href || href.charAt(0) !== '#') return null

        var target = document.querySelector(href)
        if (!target) return null

        return {
          href: href,
          link: link,
          target: target
        }
      })
      .filter(Boolean)

    if (linkItems.length === 0) return

    function centerLinkInScroller(link) {
      var scroller = link.closest('.pdp-anchor-nav__scroller')
      if (!scroller || typeof scroller.scrollTo !== 'function') return

      var linkLeft = link.offsetLeft - ((scroller.clientWidth - link.offsetWidth) / 2)
      scroller.scrollTo({
        left: Math.max(linkLeft, 0),
        behavior: prefersReducedMotion() ? 'auto' : 'smooth'
      })
    }

    function setActiveLink(activeItem, shouldCenterLink) {
      linkItems.forEach(function (item) {
        var isActive = activeItem && item.href === activeItem.href
        item.link.classList.toggle('is-active', isActive)

        if (isActive) {
          item.link.setAttribute('aria-current', 'location')

          if (shouldCenterLink) {
            centerLinkInScroller(item.link)
          }
        } else {
          item.link.removeAttribute('aria-current')
        }
      })
    }

    function updateActiveLinkFromHash() {
      var hash = window.location.hash
      var matchingItem = linkItems.find(function (item) {
        return item.href === hash
      })

      setActiveLink(matchingItem || linkItems[0], !!matchingItem)
    }

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href') || ''
        if (!href || href.charAt(0) !== '#') return

        var target = document.querySelector(href)
        if (!target) return

        var activeItem = linkItems.find(function (item) {
          return item.href === href
        })

        event.preventDefault()

        var header = document.querySelector('header[role="banner"]')
        var headerOffset = header ? header.getBoundingClientRect().height : 0
        var targetTop = target.getBoundingClientRect().top + window.pageYOffset - headerOffset - 20

        window.scrollTo({
          top: Math.max(targetTop, 0),
          behavior: prefersReducedMotion() ? 'auto' : 'smooth'
        })

        if (activeItem) {
          setActiveLink(activeItem, true)
        }

        if (window.history && typeof window.history.replaceState === 'function') {
          window.history.replaceState(null, '', href)
        }
      })
    })

    window.addEventListener('hashchange', updateActiveLinkFromHash)
    updateActiveLinkFromHash()
  }

  function setupPdpInitialScrollPosition() {
    if (window.location.hash) return

    if (window.history && 'scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual'
    }

    var resetDelays = [0, 50, 150, 300, 450]
    resetDelays.forEach(function (delay) {
      window.setTimeout(function () {
        if (window.location.hash) return
        if (window.scrollX === 0 && window.scrollY === 0) return
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
      }, delay)
    })
  }

  function setupMobileStickyAtc() {
    var stickyBar = document.querySelector('[data-mobile-sticky-atc]')
    if (!stickyBar) return

    var productSection = stickyBar.closest('[data-product-section]')
    var primaryButton = productSection ? productSection.querySelector('[data-primary-add-to-cart]') : null
    if (!productSection || !primaryButton) return

    var bundleRoot = productSection.querySelector('[data-bundle-configurator-root]')
    var footer = document.querySelector('footer')
    var lastScrollY = window.pageYOffset || 0
    var lastScrollTime = Date.now()
    var isHiddenForFastScroll = false
    var scrollStopTimer = null

    function getPageBottom(element) {
      if (!element) return 0
      var rect = element.getBoundingClientRect()
      return rect.bottom + (window.pageYOffset || 0)
    }

    function isSmallViewport() {
      return !window.matchMedia || window.matchMedia('(max-width: 767px)').matches
    }

    function setStickyVisible(shouldShow) {
      stickyBar.classList.toggle('is-visible', shouldShow)
      stickyBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true')
    }

    function updateStickyState() {
      if (!isSmallViewport()) {
        setStickyVisible(false)
        return
      }

      var scrollY = window.pageYOffset || 0
      var viewportBottom = scrollY + window.innerHeight
      var triggerBottom = Math.max(getPageBottom(primaryButton), getPageBottom(bundleRoot))
      var footerTop = footer ? footer.getBoundingClientRect().top + scrollY : Infinity
      var productBottom = getPageBottom(productSection)
      var isPastPurchaseArea = scrollY > triggerBottom - 16
      var isNearFooter = footerTop < viewportBottom + 24 || productBottom < viewportBottom + 24

      setStickyVisible(isPastPurchaseArea && !isNearFooter && !isHiddenForFastScroll)
    }

    function handleScroll() {
      var currentScrollY = window.pageYOffset || 0
      var now = Date.now()
      var deltaY = currentScrollY - lastScrollY
      var deltaTime = Math.max(now - lastScrollTime, 16)
      var speed = Math.abs(deltaY) / deltaTime

      if (deltaY < -4) {
        isHiddenForFastScroll = false
      } else if (deltaY > 240 || (deltaY > 18 && speed > 1.1)) {
        isHiddenForFastScroll = true
      }

      lastScrollY = currentScrollY
      lastScrollTime = now
      updateStickyState()

      window.clearTimeout(scrollStopTimer)
      scrollStopTimer = window.setTimeout(function () {
        isHiddenForFastScroll = false
        updateStickyState()
      }, 140)
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    window.addEventListener('resize', updateStickyState)
    updateStickyState()
  }


function initializeProductContent() {
  setupProductDescriptionEmbeds()
  setupPdpAnchorLinks()
  setupPdpInitialScrollPosition()
  setupMobileStickyAtc()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeProductContent)
} else {
  initializeProductContent()
}

})()
